// ---------------------------------------------------------------------------
// Notification-Item-Id — die eine Zerlegung `<type>:<sourceEntityId>`
// ---------------------------------------------------------------------------
//
// START-1: lebte bis v6.685 in `typeBehavior.ts`. Das Modul rechnet beim Laden
// die Registry-Projektionen aus und zieht damit die ganze Registry samt allen
// Payload-Schemas nach — und `useNotifications` (Glocke im Kopf, auf jeder
// Seite) brauchte von dort nur diese eine Zeichenketten-Zerlegung. Hier steht
// sie ohne einen einzigen Import, damit der Kopf der App den Meldungs-Apparat
// nicht ins Startbuendel zieht.

/**
 * Extrahiert die `source_entity_id` aus einer Notification-Item-`id` der
 * Form `<type>:<sourceEntityId>` (z.B. `lead_assigned:abc-123` ->
 * `abc-123`). Schemas mit zusammengesetzten Source-IDs wie
 * `<type>:<sessionKey>:<idx>` behalten alles nach dem ersten
 * Doppelpunkt. Wird vom Frontend benutzt, damit pro Row der richtige
 * Dismissal-Key ans Endpoint geht, ohne dass der Switch ueber 19 Types
 * pro Row die ID manuell zusammenbauen muss.
 */
export function sourceEntityIdFromItemId(itemId: string): string {
  const idx = itemId.indexOf(":");
  return idx === -1 ? itemId : itemId.slice(idx + 1);
}
